<template>
<div>
  <v-main class="mb-10" :class='[unfold ? "pl80" : "pl312"]'>
    <!--ダッシュボードカード-->
      <div
        width="100%"
        elevation="0"
        class="my-6 mx-6 pa-0 d-flex"
        v-for="(card, index) in navlid"
        :key="card.id+'db'"
      >
        <!--ヘッダー1:設定-->
        <!--ヘッダー2：タイトル、「詳しく見る」等-->
        <v-card width="30%" class="rounded-xl rounded-r-0 d-flex flex-column" style="background-color: #294A66">
          <v-card-title class="d-flex pr-4 pb-0 pt-4">
            <v-chip v-if="isAdmin||(card.lidAdmin.includes(uid)&&card.sanka)" class="px-2" color="faintHoney" outlined label>管理者</v-chip>
            <v-chip v-else-if="card.isOpen=='private'" class="px-2" color="cloud" outlined label>非公開</v-chip>
            <v-chip v-else-if="card.sanka" class="px-2" color="algae" outlined label>参加中</v-chip>
            <v-chip v-else class="px-2" color="white" outlined label>未参加</v-chip>
            <!--通知-->
            <div class="ml-auto">
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition" 
                max-width="30%"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                    @click="getNotify(card.id)"
                  >
                    mdi-bell
                  </v-icon>
                </template>
                <notifyList
                  :notify="lidNotify" @openModal="openDetailNotification()"
                ></notifyList>
              </v-menu>
              <!--Lid設定-->
              <v-btn v-if="isAdmin||(uid&&card.lidAdmin.includes(uid))" @click="setLidf(card.id),isLid='alid',lidId = card.id,setLid=true" icon>
                <v-icon color="white">mdi-cog</v-icon>
              </v-btn>    
            </div>
    
          </v-card-title>
          <v-card-actions class="ml-1">
            <v-img src="../assets/png/rectangle3.png" max-width="10px"></v-img>
            <v-card-title style="color:white;" class="pa-2">{{card.title}}</v-card-title>     
          </v-card-actions>
          <v-card-actions class="mx-auto">
            <router-link
              :to="'/lid/'+ card.id + '/idea'"
              class="white--text text-subtitle-1 mx-auto px-4"
              style="text-decoration:none"
            >
              <v-btn class="deepAqua rounded-pill white--text text-subtitle-1 mx-auto px-6">詳しく見る</v-btn>
            </router-link>
          </v-card-actions>
          <v-card-text class="pb-0 pt-2" style="color:white; font-size:10px;">この{{ $t('Lid') }}のメンバー</v-card-text>
          <v-card-title class="pt-0 d-flex align-baseline" style="color:white">
            <span v-if="card.counter&&card.counter.member>=0" v-text="card.counter.member"></span><span class="text-caption pl-2">人</span>
            <v-btn x-small class="cloud rounded-pill white--text pa-3 ml-auto text-caption" @click="lidId = card.id,setLidf(card.id),lidMemview=true">全員を確認</v-btn>
          </v-card-title>
          <v-card-text class="pb-0" style="color:white; font-size:10px;">今まで投稿された{{$t('アイデア')}}数</v-card-text>
          <v-card-title class="pt-0 d-flex align-baseline" style="color:white"><span v-if="card.counter&&card.counter.idea>=0" v-text="(card.counter.idea)"></span><span class="text-caption pl-2">件</span></v-card-title>
          <v-card-text class="pb-0" style="color:white; font-size:10px;">作成された{{$t('プロジェクト')}}数</v-card-text>
          <v-card-title class="pt-0 d-flex align-baseline" style="color:white"><span v-if="(card.counter&&card.counter.project>=0)" v-text="card.counter.project"></span><span class="text-caption pl-2">件</span></v-card-title>
          <v-card-text class="pb-0" style="color:white; font-size:10px;">アクティブユーザー数(本日)</v-card-text>
          <v-card-title class="pt-0 d-flex align-baseline" style="color:white"><span v-if="(card.counter&&card.counter.activeUser>=0&&yyyymmdd===card.counter.day)" v-text="card.counter.activeUser"></span><span v-else>0</span><span class="text-caption pl-2">人</span></v-card-title>
          <v-card-text class="pb-0" style="color:white; font-size:10px;" v-if="(card.lidAdmin&&card.lidAdmin[0])">管理者</v-card-text>
          <v-card-actions class="d-flex px-4" v-if="(card.lidAdmin&&card.lidAdmin[0])">
            <v-btn
              elevation="0"
              @click="profileUid = card.lidAdmin[0],profile = true"
              class="px-2 mr-auto"
              v-if="card.lidAdmin&&card.lidAdmin[0] && card.lidAdmin[0] !== 'undefined' && card.lidAdmin[0] !== 'null'"
            >
              <v-avatar size="25" v-if=profImageDict[card.lidAdmin[0]]>
                <img :src="profImageDict[card.lidAdmin[0]]">
              </v-avatar>
              <span class="font-weight-light" v-text="namelist[card.lidAdmin[0]]"></span>
            </v-btn>
            <v-btn x-small class="cloud rounded-pill white--text pa-3 ml-auto text-caption" @click="setLidf(card.id),lidId = card.id,lidAdmview=true">管理者を確認</v-btn>
          </v-card-actions>
          <v-card-actions class="mt-auto mb-4 text-center" v-if="isAuthed" style="font-size:10px;">
            <v-btn class="mx-auto rounded-pill white--text" width="80%" color="#E64550" @click="outLid(card.id,index)" v-if="card.sanka">この{{ $t('Lid') }}から退出</v-btn>
            <v-btn class="mx-auto rounded-pill white--text" width="80%" color="#399942" @click="inLid(card.id,index)" v-else>この{{ $t('Lid') }}に参加</v-btn>
          </v-card-actions>
        </v-card>
        <!--テーマ-->
        <v-card class="pa-0" width="70%">
          <v-card elevation="0" color="#CCE8FF" class="font-weight-bold overflow-y-auto ma-2 pa-2">
            <v-card-actions class="pa-0 d-flex justify-space-between">
              <p class="text-caption font-weight-bold pa-0 mb-0" style="color:#294a66">お知らせ</p>
              <p class="text-caption py-0 pl-0 mb-0" style="color:#707070;" v-if="card.noticeTime"><span style="font-size:10px">更新日時</span><span v-if="card.noticeTime" v-text="card.noticeTime.toDate().toLocaleString()"></span></p>
            </v-card-actions>
            <v-card-actions class="d-flex pa-0">
              <p class="pa-0 mb-0 overflow-auto noScroll" style="max-height:100px;"><span class="font-weight-regular" v-if="card.notice" v-dompurify-html="card.notice"></span><span class="text-center font-weight-thin" style="font-size:15px; color:#707070;" v-else>まだお知らせはありません</span></p>
              <div class="ml-auto" v-if="isAdmin||(uid&&card.lidAdmin.includes(uid))">
                <v-fab-transition>
                  <v-btn color="#294A66" dark fab x-small @click="editNotice=true,notice = card.notice,lidIndex = index,lidId = card.id"><v-icon>mdi-pencil-plus</v-icon></v-btn>
                </v-fab-transition>
              </div>
            </v-card-actions>
          </v-card>
          <div class="mx-auto" style="color:#294a66; background-color:#f1f1f1; width:96%;">
            <v-tabs 
              color="basil"
              grow
            >
            <v-tab>ワードクラウド</v-tab>
            <v-tab @click="isNega=true">ネガティブ・ポジティブ反応</v-tab>
            <v-tab @click="isD3=true">共起ネットワーク</v-tab>
              <v-tab-item width="90%" style="background-color:#DCDCDC65">
                <v-card-actions>
                  <MakeWordCloud :lidid="card.id" :word_dict="card.word_dict" :height="'38vh'" :width="'100%'" :comment="true"> </MakeWordCloud>      
                </v-card-actions>
              </v-tab-item>
              <v-tab-item width="90%" style="background-color:#DCDCDC65">
                <!-- <p style="color:#294A66">ネガティブ・ポジティブ反応</p> -->
                <MakeNegaPosiChart
                  v-bind:nega_posi_all="card.nega_posi_all" 
                  v-bind:maxposi_cont="card.maxposi_cont" 
                  v-bind:maxnega_cont="card.maxnega_cont"
                  :dash="false"
                  :lidid="card.id"
                  height="600" width="1200"
                  v-if="isNega"
                ></MakeNegaPosiChart> 
              </v-tab-item>
              <v-tab-item width="90%" style="background-color:#DCDCDC65">
                <MakeD3Network v-if="isD3" v-bind:words_list="card.words_list" v-bind:word_dict="card.word_dict" v-bind:edge_dict="card.edge_dict" :height="'400px'" :width="'100%'" :force="1900"> </MakeD3Network>
              </v-tab-item>
            </v-tabs>     
          </div>

          <v-row class="ma-2">
            <v-col cols="6" class="py-0">
              <v-card class="pa-2 d-flex flex-column" color="#f1f1f1" flat style="height:100%;">
                <v-card-actions
                  class="font-weight-bold pa-0"
                  style="color: #294a66"
                >
                  <p class="mb-2">参加者数</p>
                </v-card-actions>
                <v-card-text class="pa-0">
                  <v-sheet color="#dcdcdc" v-if="card&&card.counter&&card.counter.days&&card.counter.days.daynum">
                    <v-sparkline
                      :labels="[day1,day2,day3,day4,day5,day6,day7]"
                      :value="[
                        card.counter.days.daynum[0] || 0,
                        card.counter.days.daynum[1] || 0,
                        card.counter.days.daynum[2] || 0,
                        card.counter.days.daynum[3] || 0,
                        card.counter.days.daynum[4] || 0,
                        card.counter.days.daynum[5] || 0,
                        card.counter.member 
                      ]"
                      color="#294A66"
                      height="140"
                      padding="24"
                      stroke-linecap="round"
                      smooth
                    >
                    </v-sparkline>
                  </v-sheet>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-around mt-auto pa-0" style="font-size:15px; color:#707070;" v-if="card&&card.counter">
                  <v-sheet class="d-flex pa-1">
                    <p class="mb-0">本日<span style="font-size:20px !important;" v-if="sankaNumToday(card.counter)>=0" v-text="sankaNumToday(card.counter)"></span>件</p>
                  </v-sheet>
                  <v-sheet class="d-flex pa-1">
                    <p class="mb-0">今週<span style="font-size:20px !important;" v-if="sankaNumWeek(card.counter)>=0" v-text="sankaNumWeek(card.counter)"></span>件</p>
                  </v-sheet>
                  <v-sheet class="d-flex pa-1">
                    <p class="mb-0">今月<span style="font-size:20px !important;" v-if="sankaNumMonth(card.counter)>=0" v-text="sankaNumMonth(card.counter)"></span>件</p>
                  </v-sheet>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="6" class="pa-0">
              <!--議論中のプロジェクト-->
              <v-card
                elevation="0"
                class="font-weight-bold pa-2 ma-0 text-center"
                color="#f1f1f1"
                style="height:48%;"
              >
                <v-card-actions
                  class="font-weight-bold pa-0 d-flex justify-space-between"
                  style="color: #294a66"
                >
                  <p class="mb-2">対話が活発な{{$t('プロジェクト')}}</p>
                  <p v-if="(card.counter&&card.counter.disPj)"><span>{{ card.counter.disPj }}</span><span class="" style="color: #707070; font-size: 12px">件</span></p>
                </v-card-actions>
                <p class="text-caption my-0 text-right">上位1件</p>
                
                <div v-if="card.counter&&card.counter.disPj>0">
                  <v-card class="mx-auto areapj" color="white" style="border-bottom: medium solid #399942 !important;">
                    <v-card-text class="gren1 pa-2" v-if="card.preview&&card.preview.disPj">
                      <span style="font-size:8px">{{$t('プロジェクト')}}</span>
                      <br />{{ card.preview.disPj }}
                    </v-card-text>
                  </v-card>  
                </div>
                <div v-else><v-card-text class="pa-2" style="color: #707070; font-size:12px;"> 議論中の{{$t('プロジェクト')}}はありません </v-card-text></div>
              </v-card>
              <!--投票中のプロジェクト-->
              <v-card
                elevation="0"
                class="font-weight-bold pa-2 mx-0 mb-0 mt-2 text-center"
                color="#f1f1f1"
                style="height:48%;"
              >
                <v-card-actions
                  class="font-weight-bold pa-0 d-flex justify-space-between"
                  style="color: #294a66"
                >
                  <p class="mb-2">投票中の{{$t('プロジェクト')}}</p>
                  <p v-if="(card.counter&&card.counter.votePj)"><span>{{ card.counter.votePj }}</span><span class="" style="color: #707070; font-size: 12px">件</span></p>
                </v-card-actions>
                <p class="text-caption my-0 text-right">最新1件</p>
                <div v-if="(card.counter&&card.counter.votePj==0)">
                  <v-card class="mx-auto areapj" color="white" style="border-bottom: medium solid #BA0009 !important;">
                    <v-card-text class="gren2 pa-2" style="color: #707070;" v-if="card.preview&&card.preview.votePj">
                      <span style="font-size:8px">{{$t('プロジェクト')}}</span>
                      <br />{{ card.preview.votePj }}
                    </v-card-text>
                  </v-card>  
                </div>
                <div v-else><v-card-text class="pa-2" style="color: #707070; font-size:12px;"> 投票中の{{$t('プロジェクト')}}はありません </v-card-text></div>
              </v-card>
            </v-col>          
          </v-row>
        </v-card>
      </div>
  </v-main>
  <!--フッター： style="position:fixed; bottom:0px; width:100%;"-->
  <v-footer :class='[unfold ? "pl80" : "pl312"]' padless style="position:fixed; bottom:0px; width:100%;" class="d-flex flex-column">
    <v-card elevation="0" class="text-center font-weight-bold" color="lava" height="48px" v-if="!isAuthed" style="width:100%; color: white;">
      <p class="pt-3 text-center" style="width:100%; font-size: 16px;" @click="authModal=true">現在ログインしていません。ここをタッチして、参加しましょう！</p>
    </v-card>
    <v-card class="flex" flat tile color="#dcdcdc" width="100%">
      <div class="py-0 text-center" v-if="config && config.inquiry" style="width: 100%;">
        <p class="mb-0">お問い合わせ：<span v-text="config.inquiry"></span></p>
        <a v-if="config && config.inquiryUrl" :href="config.inquiryUrl" target="_blank" rel="noopener">{{ config.inquiryUrl }}</a>
      </div>
      <v-card-text class="py-0 text-center">
        <span>&copy;</span> {{ new Date().getFullYear() }} — <strong>Liquitous</strong>
      </v-card-text>
    </v-card>
  </v-footer>

  <!--サインイン画面-->
  <v-dialog v-model="authModal" width="400px" height="60%">
    <auth-view
      defaultView="chooseauth"
      @closeModal="closeAuthModal"
    >
    </auth-view>
  </v-dialog>

  <!--お知らせ編集-->
  <v-dialog v-model="editNotice" width="80%" persistent @keydown.esc="editNotice = false">
    <v-card height="95%">
      <v-card-actions class="my-0">
        <h3>テーマページ本文</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="notice = '',editNotice = false">
          <v-icon x-large>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions>
        <quill-editor 
          v-model="notice"
          rows="6"
          :options="pjEditorOption"
          class="pt-0 ma-2"
          style="border:none; height: 65vh; width: 100%;"
          ref="quillEditor"
        >
        </quill-editor>
      </v-card-actions>
      <v-card-actions class="mt-8">
        <v-spacer></v-spacer>
        <v-btn class="mx-2 deepAqua white--text px-8 rounded-pill" @click="submitNotice(),editNotice = false">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!--Lid削除画面-->
  <v-dialog v-model="removeSublid" height="80%" width="60%">
    <v-card class="pa-2" style="overflow:hidden">
      <v-card-actions class="flex-column justify-center">
        <v-card-title class="font-weight-bold py-2 text-center" style="font-size:26px;">{{ $t('Lid') }}の削除</v-card-title>
        <v-card-text class="pb-0 pt-2 text-center">
          Lidを削除する理由を記入してください。
        </v-card-text>
        <v-card-text class="pb-0 pt-2 text-center">
          <span class="font-weight-bold deepLava--text">{{ $t('Lid') }}を削除する</span>と、{{ $t('Lid') }}内の{{$t('アイデア')}}や{{$t('プロジェクト')}}も削除されます。
        </v-card-text>     
      </v-card-actions>
      <v-textarea
        outlined
        class="px-10 pt-2"
        filled
        background-color="white"
        label="削除理由"
        auto-grow
        v-model="removeReason"
        height="260px"
      ></v-textarea>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          @click="checkRemoveSublid=false"
        >
          削除しない
        </v-btn>
        <v-btn
          class="px-6 deepLava"
          rounded dark
          @click="checkRemoveSublid=true"
        >
          削除する
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!--Lid詳細画面-->
  <v-dialog
    v-model="setLid"
    width="800"
    @keydown.esc="setLid = false"
    persistent
  >
  <v-card
    class="px-6"
  >
    <v-card-actions>
      <v-card-title class="font-weight-bold my-2 py-2 pl-0" style="font-size:26px;">{{ $t('Lid') }}の設定</v-card-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="setLid = false">
        <v-icon x-large>mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <div class="overflow-y-auto overflow-x-hidden" style="height:65vh;">
      <!--Lid名-->
      <v-card-actions>
        <v-row>
          <v-img class="pr-0" max-height="100" max-width="10" src="../assets/png/rectangle.png"></v-img>
          <v-col class="py-0 pl-2">
            <v-text-field
              hide-details
              v-model="onelidName"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-actions>
      <!--Lidメンバー-->
      <v-card-actions style="font-size:18px; color:#707070" class="mt-2 pt-0 pl-2">
        <p class="mb-0">{{ $t('Lid') }}のメンバー</p>
        <v-btn
          color="#707070" dark small
          data-testid="addLid_setLid_LidMemeberEdit"
          class="rounded-xl ml-4"
          @click="lidMemview=true"
        >
          <v-icon color="white" x-small>mdi-cog</v-icon>
          編集
        </v-btn>
      </v-card-actions>
      <v-card-text class="pl-2 pb-0 pt-2"><span class="font-weight-bold text-h4" style="color:#2B2B2B" v-text="lidmemberNum"></span>人</v-card-text>  

      <!--Lid管理者-->
      <v-card-actions style="font-size:18px; color:#707070" class="mt-2 pt-0 pl-2">
        <p class="mb-0">{{ $t('Lid') }}の管理者</p>
        <v-btn
          color="#707070" dark small
          data-testid="dashboard_setLid_LidAdminEdit"
          class="rounded-xl ml-4"
          @click="lidAdmview = true"
        >
          <v-icon color="white" x-small>mdi-cog</v-icon>
          編集
        </v-btn>
      </v-card-actions>
      <v-card-actions class="" v-if="lidAdmin.length>0">
        <v-btn
          elevation="0"
          @click="profileUid = lidAdmin[0],profile = true"
          class="px-2"
        >
          <v-avatar size="25" v-if=profImageDict[lidAdmin[0]]>
            <img :src="profImageDict[lidAdmin[0]]">
          </v-avatar>
          <span class="text-caption" v-text="namelist[lidAdmin[0]]"></span>
        </v-btn>
        <p class="text-caption pt-2 mb-0 pb-0" style="color:white">ほか</p>
      </v-card-actions>


      <!--Lid公開設定-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        {{ $t('Lid') }}の公開設定
      </v-card-text>
      <v-card-actions class="pl-2 py-0">
        <v-radio-group
          v-model="isOpen"
          row
        >
        <v-radio
          label="公開"
          value="public"
        ></v-radio>
        <v-radio
          v-if="authConfig.officer"
          label="庁内運用Lid"
          value="privateAndOpenedForGov"
        ></v-radio>
        <v-radio
          label="非公開"
          value="private"
        ></v-radio>
        </v-radio-group>
      </v-card-actions>

      <!--Lidアイデアテーマ-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        {{$t('アイデア')}}出しのテーマ<span style="font-size:14px;">(20字以内)</span>
      </v-card-text>        
      <v-card-actions class="pl-2">
        <v-text-field
            clearable
            placeholder="未入力"
            color="#DCDCDC"
            v-model="oneideaTheme"
        ></v-text-field>
      </v-card-actions>

      <!--Lidアイデアプレースホルダー-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        {{$t('アイデア')}}のプレースホルダー<span style="font-size:14px;">(20字以内)</span>
      </v-card-text>        
      <v-card-actions class="pl-2">
        <v-text-field
            clearable
            placeholder="未入力"
            color="#DCDCDC"
            v-model="oneideaHolder"
        ></v-text-field>
      </v-card-actions>

      <!--Lidアイデアタグの設定-->
      <v-card-actions style="font-size:18px; color:#707070" class="mt-2 pt-0 pl-2">
        <p class="mb-0">{{$t('アイデア')}}出しのタグ設定</p>
        <v-btn
          color="#707070" dark small
          data-testid="dashboard_setLid_LidAdminEdit"
          class="rounded-xl ml-4"
          @click="tagsSet(true)"
        >
          <v-icon color="white" x-small>mdi-cog</v-icon>
          編集
        </v-btn>
      </v-card-actions>
      <v-card-actions class="pl-2">
        <v-chip-group v-if="onetags&&onetags.title&&onetags.title.length>0" :show-arrows="true" >
          <v-chip
            v-for="(tag,index) in onetags.title"
            :key="tag"
            class="my-auto"
          >
            <v-icon :color="onetags.color[index]">mdi-circle</v-icon>
            {{ tag }}
          </v-chip>
        </v-chip-group>
        <p v-else class="mb-0 cloud--text ml-2">タグが設定されていません</p>
      </v-card-actions>
      <v-checkbox
        v-if="onetags.title.length>0"
        :label="$t('アイデア')+'投稿時のタグを必須にする'"
        @click="tagsSet(true)"
        class="mt-0 pl-3"
        v-model="onetags.required"
        readonly
      ></v-checkbox>

      <!--Lid前提情報ページの設定-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        [{{ $t('Lid') }}] {{$t("前提情報")}}ページの設定
      </v-card-text>        
      <v-card-actions class="pl-2">
        <v-btn rounded class="my-2 white--text cloud"><router-link :to="'/lid/'+lidId+'/content'" style="text-decoration: none;" class="white--text">設定</router-link></v-btn>
      </v-card-actions>

      <!--コンテンツページでのアイデア投稿有効化-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        コンテンツページでの{{$t('アイデア')}}投稿有効化
      </v-card-text>
      <v-card-actions class="pl-2 py-0">
        <v-radio-group
          v-model="postIdeaOnContent"
          row
        >
        <v-radio
          label="有効"
          value="true"
        ></v-radio>
        <v-radio
          label="無効"
          value="false"
        ></v-radio>
        </v-radio-group>
      </v-card-actions>

      <!--アイデア匿名投稿-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        {{$t('アイデア')}}匿名投稿
      </v-card-text>
      <v-card-actions class="pl-2 py-0">
        <v-radio-group
          v-model="postIdeaAnonymous"
          row
        >
        <v-radio
          label="有効"
          value="true"
        ></v-radio>
        <v-radio
          label="無効"
          value="false"
        ></v-radio>
        </v-radio-group>
      </v-card-actions>


      <!--アイデアスレッド-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0" v-if="idea_thread">
        {{$t('アイデア')}}チャット
      </v-card-text>
      <v-card-actions class="pl-2 py-0" v-if="idea_thread">
        <v-radio-group
          v-model="isOpenIdeaThread"
          row
        >
        <v-radio
          label="有効"
          value="true"
        ></v-radio>
        <v-radio
          label="無効"
          value="false"
        ></v-radio>
        </v-radio-group>
      </v-card-actions>

      <!--アイデア投稿の無効化-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        {{$t('アイデア')}}投稿の無効化
      </v-card-text>
      <v-card-actions class="pl-2 py-0">
        <v-radio-group
          v-model="isIdeaSubmitDisabled"
          row
        >
        <v-radio
          label="投稿を無効にする"
          value="true"
        ></v-radio>
        <v-radio
          label="投稿は有効にする"
          value="false"
        ></v-radio>
        </v-radio-group>
      </v-card-actions>

      <!--Lidの削除-->
      <v-card-text style="font-size:18px; color:#707070" class="pl-2 pb-0">
        {{ $t('Lid') }}の削除
      </v-card-text>
      <v-card-actions class="pl-2 py-0">
        <v-btn rounded class="white--text deepLava px-4 my-2" @click="removeSublid=true" style="text-decoration:none;">
          {{ $t('Lid') }}の削除
        </v-btn>
      </v-card-actions>      
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        rounded
        color="#008CFF"
        class="white--text px-8"
        @click="setLid = false,submitLid()"
      >
      設定完了
      </v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>

  <v-dialog v-model="checkRemoveSublid" height="90%" width="40%">
    <v-card
      color="white" class="pa-6"
    >
      <p class="font-weight-bold py-2 text-h5 text-center"><font color="black">{{ $t('Lid') }}の削除</font></p>
      <p class="pt-2 text-center"><font color="black">本当に{{ $t('Lid') }}を削除しますか？</font></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip
          class="mr-4"
          @click="checkRemoveSublid = false"
        >
        削除しない
        </v-chip>
        <v-chip
          @click="checkRemoveSublid = false, removingSublid()"
          color="deepLava"
          dark
        >
          削除する
        </v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!--Lid管理者画面-->
  <v-dialog
    v-model="lidAdmview"
    width="800"
    @keydown.esc="lidAdmview = false" 
    persistent
  >
    <listAdm :lidId="lidId" :lidTitle="oneLid.title" mode="lid" @listAdmClose="oneaddAdmin"></listAdm>
  </v-dialog>
  <!--Lidメンバー画面-->
  <v-dialog
    v-model="lidMemview"
    width="800"
    @keydown.esc="lidMemview = false" 
    persistent
  >
    <listMem :lidId="lidId" :lidTitle="oneLid.title" mode="lid" @listMemClose="oneaddMember" @lidCandiMems="onecandiMembers"></listMem>
  </v-dialog>
  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="profileUid"
    device="pc"
    @closeProfile="closeProfile"
  ></profile_display>
  <!--ideaタグ画面-->
  <v-dialog v-model="setTag" persistent width="500">
    <v-card class="pa-2">
      <v-card-actions class="align-center">
        <h2>{{$t('アイデア')}}出しのタグ追加</h2>
        <v-spacer></v-spacer>
      </v-card-actions>
      <p class="mb-0 ml-6">
        タグは10個まで設定できます。
      </p>
      <v-container v-if="tagNames&&tagNames.length>0" class="overflow-y-auto" style="max-height: 55vh;">
        <v-card-actions class="justify-center align-center mx-0" v-for="n in tagNum" :key="n">
          <div v-if="n<=tagNum_&&tagNames&&tagNames.length>0" class="d-flex align-center" style="width:100%;">
            <p class="mb-0 mx-2">タグ{{ n }}</p>
            <v-chip class="mb-0 mx-auto">
              <v-icon :color="tagColors[n-1]">mdi-circle</v-icon>
              {{ tagNames[n-1] }}
            </v-chip>
            <v-btn v-if="tagNum>1" @click="tagDeleteAlert=true,tagDelNum=n">削除</v-btn>
            <v-btn v-else-if="tagNum===1" @click="tagDeleteAlert=true,tagDelNum=n">削除</v-btn>
          </div>
          <div v-else class="d-flex align-center" style="width:100%;">
            <p class="mb-0 mx-2">タグ{{ n }}</p>
            <v-menu
              v-model="selectColor"
              :close-on-content-click="false"
              :nudge-width="180"
              offset-y hide-details
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on" tile depressed class="px-0" @click="k=n"
                >
                  <v-icon :color="tagColors[n-1]">mdi-circle</v-icon>
                </v-btn>
              </template>
              <v-card v-if="n==k">
                <v-card-text class="pa-2 pb-0">タグの色(色をクリックして選択)</v-card-text>
                <v-card-actions>
                  <v-btn @click="tagColors[n-1] = '#2B2B2B'" icon><v-icon color="#2B2B2B" size="50">mdi-circle</v-icon></v-btn> 
                  <v-btn @click="tagColors[n-1] = '#294A66'" icon><v-icon color="#294A66" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#008CFF'" icon><v-icon color="#008CFF" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#399942'" icon><v-icon color="#399942" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#54E363'" icon><v-icon color="#54E363" size="50">mdi-circle</v-icon></v-btn>
                </v-card-actions>
                <v-card-actions>
                  <v-btn @click="tagColors[n-1] = '#DCDCDC'" icon><v-icon color="#DCDCDC" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#BA0009'" icon><v-icon color="#BA0009" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#FF8796'" icon><v-icon color="#FF8796" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#E05922'" icon><v-icon color="#E05922" size="50">mdi-circle</v-icon></v-btn>
                  <v-btn @click="tagColors[n-1] = '#FFB336'" icon><v-icon color="#FFB336" size="50">mdi-circle</v-icon></v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-text-field placeholder="タグの名前を入力(10字以内)" color="#DCDCDC" v-model="tagNames[n-1]" class="mx-2 pt-0" counter="10" :rules="[v => v.length <= 10 || '10文字まで入力できます']"></v-text-field>
            <v-btn @click="tagNum--,tagNames.splice(n-1,1),tagColors.splice(n-1,1)" v-if="tagNum>1">削除</v-btn>
            <v-btn @click="tagNum--,tagNames=[],tagColors=[]" v-else-if="tagNum===1">削除</v-btn>
          </div>
        </v-card-actions>
      </v-container>
      <p v-else class="my-2 text-center">タグが設定されていません</p>
      <v-card-actions class="justify-center">
        <v-btn @click="tagNum++,tagNames[tagNum-1]='',tagColors[tagNum-1]=tagColors0[tagNum-1]" :disabled="issetTagAdd" v-if="tagNum<10">+設定するタグを追加</v-btn>
      </v-card-actions>
      <v-checkbox
        v-if="tagNum>0"
        :label="$t('アイデア')+'投稿時のタグを必須にする'"
        class="pl-4 mt-0" hide-details
        v-model="tagRequired"
      ></v-checkbox>
      <!--後日実装-->
      <v-checkbox
        v-if="onetags.title.length&&false"
        label="削除されたタグを表示しない"
        class="pl-4 mt-0" hide-details
        v-model="oldtagHided"
      ></v-checkbox>
      <p v-if="isEmpty" class="my-2 text-center deepLava--text">タイトルが空白のタグがあります</p>
      <p v-if="!isUnDup" class="my-2 text-center deepLava--text">タイトルが重複しているタグがあります</p>
      <v-card-actions class="justify-center">
        <v-chip class="px-4 mx-2" @click="setTag = false,tagsSet(false)">キャンセル</v-chip>
        <v-chip class="px-8" @click="setTag = false,submitLidTags()" color="deepAqua" dark :disabled="issetTagUpdate">更新</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="tagDeleteAlert" height="90%" width="40%">
    <v-card
      color="white"
      elevation="15"
      class="pt-6"
    >
      <p class="pt-6 px-8 font-weight-bold text-h5 text-center"><font color="black">タグを削除しますか？</font></p>
      <p class="pt-6 px-8 text-center"><font color="black">タグを削除すると、既に紐づいている{{$t('アイデア')}}のタグも表示されなくなります。</font></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip
          class="ma-4 pa-4 font-weight-bold"
          @click="tagDeleteAlert = false"
        >削除しない</v-chip>
        <v-chip v-if="tagNum>1"
          class="ma-4 pa-4 font-weight-bold"
          @click="tagDeleteAlert = false, tagNum--, tagNum_--, tagNames.splice(tagDelNum-1,1), tagColors.splice(tagDelNum-1,1)"
          color="deepLava"
          dark
        >削除する</v-chip>
        <v-chip v-else-if="tagNum===1"
          class="ma-4 pa-4 font-weight-bold"
          @click="tagDeleteAlert = false, tagNum--, tagNames=[], tagColors=[]"
          color="deepLava"
          dark
        >削除する</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!--通知詳細画面-->
  <v-dialog v-model="detailNotification" width="90%" height="80%" style="z-index:900;">
    <notifyDetail :notify="lidNotify" @closeModal="closeDetailNotification()"></notifyDetail>
  </v-dialog>
  <navigator @doFold="onedoFold" @wskey="wsSet"></navigator>
</div>
</template>

<script>
import navigator from '../components/navigator.vue'
// import listMem from '../components/listMem.vue'
// import listAdm from '../components/listAdm.vue'
// import profile_display from "../components/profile/profile_display.vue";
// import authView from '../components/auth/authView.vue';
const listMem = () => import('../components/listMem.vue')
const listAdm = () => import('../components/listAdm.vue')
const profile_display = () => import('../components/profile/profile_display.vue')
const authView = () => import('../components/auth/authView.vue')
import firebase from 'firebase'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import MakeWordCloud from '../components/idea/MakeWordCloud.vue';
import MakeD3Network from '../components/idea/MakeD3Network.vue'
import MakeNegaPosiChart from '../components/idea/MakeNegaPosiChart.vue'
import notifyList from '../components/notifyList.vue'
import notifyDetail from '../components/notifyDetail.vue'
// import MakeD3Network from '../components/idea/MakeD3Network.vue';
// import MakeNegaPosiChart from '../components/idea/MakeNegaPosiChart.vue';
import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})

Vue.use(VueDOMPurifyHTML)
export default {
  components: {
    quillEditor,
    navigator,
    listAdm,
    listMem,
    profile_display,
    MakeWordCloud,
    MakeD3Network,
    MakeNegaPosiChart,
    authView,
    notifyList,
    notifyDetail
  },
  data: () => ({
    db : null,
    isLid: "lid",
    authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
    isD3: false,
    isNega: false,
    day1: "6日前",
    day2: "5日前",
    day3: "4日前",
    day4: "3日前",
    day5: "2日前",
    day6: "1日前",
    day7: "今日",
    day1_: null,
    day2_: null,
    day3_: null,
    day4_: null,
    day5_: null,
    day6_: null,
    day7_: null,
    unfold: false,
    num : 0,
    todayy: null,
    yyyy : null,
    mm : null,
    dd : null,
    hh : null,
    mi : null,
    se : null,
    ms : null,
    yyyymmdd: null,
    yyyymm: null,
    timeday: null,
    timehour: null,
    profile: false,
    profileUid: "",
    menu: false,
    uploadedImage: '',
    emailaddress:'',
    position:"",
    nomemif:true,
    isOpen:"public",
    postIdeaOnContent: 'false',
    postIdeaAnonymous: 'true',
    isOpenIdeaThread: 'false',
    isIdeaSubmitDisabled: 'false',
    setLid:false,
    onelidName: "",
    lidmemberNum: 0,
    oneideaTheme:"",
    oneideaHolder:"",
    oneideaDesc:"",
    lidAdmin: [],
    onetags: {
      title: [],
      color: [],
      required: false,
      oldtagHided: false
    },
    candiAdmin:[],
    addMem: false,
    deleMem: false,
    candiMem: [],
    lidMemview:false,
    lidAdmview:false,
    removeSublid:false,
    removeReason:"",
    checkRemoveSublid:false,
    oneLid: {},
    notice: "",
    editNotice: false,
    lidId: "",
    lidTitle: "",
    lidNotify: [],
    lidNotifyId: "",
    pjEditorOption: {
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'font': [] }],
          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          //['blockquote', 'code-block'],
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'align': [] }],
          ['link'],
          //['clean'] 
          // ['image','video'],                                  // remove formatting button
        ],
      },
      placeholder: "ここに入力してください",
    },
    nega_posi_all: [],
    word_dict:{},

    selectColor: false,
    setTag: false,
    tagNames: [],
    tagNum: 0,
    tagNum_ : 0,
    tagDelNum: 0,
    tagRequired: false,
    oldtagHided: false,
    k:0,
    //登録するタグリスト
    tagColors:[
      "#2B2B2B",
      "#294A66",
      "#008CFF",
      "#399942",
      "#54E363",
      "#DCDCDC",
      "#BA0009",
      "#FF8796",
      "#E05922",
      "#FFB336"
    ],
    //タグ色のオリジナル
    tagColors0:[
      "#2B2B2B",
      "#294A66",
      "#008CFF",
      "#399942",
      "#54E363",
      "#DCDCDC",
      "#BA0009",
      "#FF8796",
      "#E05922",
      "#FFB336"
    ],
    authModal: false,
    detailNotification: false,
    tagDeleteAlert: false,
    ws: {},
  }),
  created() {
    this.db = firebase.firestore() // dbインスタンスを初期
    this.today()
    this.$store.dispatch("getCounter")
  },
  computed: {
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    profImageDict(){
      return this.$store.state.profImageDict
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    config(){
      return this.$store.state.config
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    navlid(){
      //公開Lid（フォルダに属す属さない関係なく）
      //console.log(this.$store.state.lid)
      let navlid = []
      this.$store.getters.navlid.forEach((lid)=>{
        if (lid.isfolder) {
          navlid = navlid.concat(lid.childlids)
        } else {
          navlid.push(lid)
        }
      })
      if (this.isWs&&this.eachWs&&this.eachWs.lids) {
        navlid = navlid.filter((el) => this.eachWs.lids.includes(el.id)).concat(navlid.filter((el)=>!el.isWs))
      }
      return navlid
    },
    eachWs() {
      let id = this.$route.query.id;
      if (id) {
        return this.wss.find((el) => el.id === id);
      } else {
        return null
      }
    },
    wss() {
      return this.$store.getters.wss;
    },
    alid(){
      let alid = this.$store.state.alid
      if(this.isWs&&this.eachWs&&this.eachWs.lids){
        alid = alid.filter((el)=>{this.eachWs.lids.includes(el.id)})
      }
      return alid
    },
    lidusers(){
      return this.$store.state.lidusers
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    isWs(){
      if (this.$store.getters.wss?.length&&this.$route.query.id) return true
      else return false
    },
    idea_thread(){
      if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_thread) return this.$store.state.config.setting.idea_thread
      else return false
    },
    issetTagAdd(){
      let isT
      if(this.tagNames&&this.tagNames.length>0) isT = this.isEmpty || !this.isUnDup ||this.tagNames[this.tagNum-1] == '' || this.tagNames[this.tagNum-1] == undefined || this.tagNames[this.tagNum-1] == null
      else isT = false
      return  isT
    },
    issetTagUpdate(){
      let isT
      if(this.tagNames&&this.tagNames.length>0) isT = this.isEmpty || !this.isUnDup ||this.tagNames[this.tagNum-1] == '' || this.tagNames[this.tagNum-1] == undefined || this.tagNames[this.tagNum-1] == null
      else isT = true
      return  isT
    },
    isEmpty(){
      //タグのタイトルに空白があるか
      let isEmpty = false
      const setElements = new Set(this.tagNames)
      isEmpty = setElements.has("")
      return isEmpty
    },
    isUnDup(){
      //タグのタイトルが重複していないか
      let isUnDup = false
      const setElements = new Set(this.tagNames)
      isUnDup = setElements.size === this.tagNames.length
      //console.log("isUnDup:",isUnDup,setElements,this.tagNames,setElements.size,this.tagNames.length)
      return isUnDup
    },
  },
  methods: {
    wsSet(el) {
      if(el==="home"){
        this.$router.push("/dashboard")
      }
      else{
        this.$router.push("/dashboard?id="+el.id)
      }
    },
    sankaNumToday(counter){
      const date = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000))
      let dd = date.getDate()
      const weeknum = Math.floor((dd - date.getDay() + 12 ) / 7)
      if(counter.days[this.day7]&&counter.days[this.day7].in){
        if(counter.yyyy===this.yyyy&&counter.mm==this.mm&&counter.weeknum===weeknum){
          return counter.days[this.day7].in.length
        }
        else return 0
      }
      else return 0
    },
    sankaNumWeek(counter){
      const date = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000))
      let dd = date.getDate()
      const weeknum = Math.floor((dd - date.getDay() + 12 ) / 7)
      if(counter.days.week){
        if(counter.yyyy===this.yyyy&&counter.mm==this.mm&&counter.weeknum===weeknum){
          return counter.days.week
        }
        else return 0
      }
      else return 0
    },
    sankaNumMonth(counter){
      if(counter.days.month){
        if(counter.yyyy==this.yyyy&&counter.mm==this.mm){
          return counter.days.month
        }
        else return 0
      }
      else return 0
    },
    tagsSet(el){
      if(this.onetags?.title?.length>0){
        this.tagNames=this.onetags.title.concat()
        this.tagColors=this.onetags.color.concat()
        this.tagNum=this.onetags.title.length
        this.tagNum_=this.onetags.title.length
        this.tagRequired=this.onetags.required || false
        this.oldtagHided=this.onetags.oldtagHided || false
      }
      else{
        this.tagNames=[]
        this.tagColors=this.tagColors0.concat()
        this.tagNum = 0
        this.tagNum_ = 0
        this.tagRequired=false
        this.oldtagHided=false
      } 
      this.setTag=el
    },
    //タイトルからLidデータを引き出す
    setLidf(el){
      //this.oneLid.counter_member = 0
      this.oneLid = this.navlid.filter(function(object) {
        return object.id == el
      }).shift()
      if(this.oneLid == undefined){
        this.oneLid = this.alid.filter(function(object) {
          return object.id == el
        }).shift()
      }
      //console.log(this.oneLid)
      this.isOpen = (this.authConfig.officer && this.oneLid?.isOpenForGovStaff!=false) ? 'privateAndOpenedForGov' : this.oneLid.isOpen
      this.onetags = this.oneLid.tags || {title:[],color:[]}
      this.oneideaTheme = this.oneLid.ideaTheme
      this.oneideaHolder = this.oneLid.ideaHolder
      this.oneideaDesc = this.oneLid.ideaDesc
      this.onelidName = this.oneLid.title
      this.postIdeaOnContent = this.oneLid?.settings?.postIdeaOnContent ? 'true' : 'false'
      this.postIdeaAnonymous = this.oneLid?.settings?.postIdeaAnonymous == false ? 'false' : 'true'
      this.isOpenIdeaThread = this.oneLid?.settings?.isOpenIdeaThread ? 'true' : 'false'
      this.isIdeaSubmitDisabled = this.oneLid?.settings?.isIdeaSubmitDisabled ? 'true' : 'false'
      this.lidmemberNum = this.oneLid.counter.member
      if(typeof this.lidmemberNum!="number") this.lidmemberNum = 0
      this.lidId = el
      this.lidAdmin = this.oneLid.lidAdmin //要調整
      //this.$store.dispatch('getLidMembers',el)
    },
    inLid(lidId,index){
      this.$store.dispatch('inLid',{lidId:lidId,uid:this.uid})
      this.$store.commit("addLidMem1", index)
    },
    outLid(lidId,index){
      this.$store.dispatch('outLid',{lidId:lidId,uid:this.uid})
      this.$store.commit("deLidMem1", index)
    },
    //Lid更新
    submitLid() {
      let self = this
      //console.log("submitLid",this.isOpen , this.onelidName,this.oneideaTheme)
      this.db.collection("0").doc(this.lidId).update({
        isOpen:this.isOpen == 'privateAndOpenedForGov' ? 'private' : this.isOpen,//公開かどうか
        isOpenForGovStaff: !!(this.authConfig.officer && this.isOpen == 'privateAndOpenedForGov'),
        ideaTheme: self.oneideaTheme,
        ideaHolder: self.oneideaHolder || "",
        title: self.onelidName,
        settings: {
          ...self.oneLid.settings,
          // booleanに変換
          postIdeaOnContent: self.postIdeaOnContent == "true" ? true : false,
          postIdeaAnonymous: self.postIdeaAnonymous == "true" ? true : false,
          isOpenIdeaThread: self.isOpenIdeaThread == "true" ? true : false,
          isIdeaSubmitDisabled: self.isIdeaSubmitDisabled == "true" ? true : false,
        },
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      }).then(function(docRef) {
      // 保存に成功した時
        self.isOpen = "public"
        self.oneideaTheme = ""
        self.oneideaHolder = ""
        self.onelidName = ""
        self.inHomeTo = "idea" 
        self.postIdeaOnContent = 'false'
        self.postIdeaAnonymous = 'true'
        self.isOpenIdeaThread = 'false'
        self.isIdeaSubmitDisabled = 'false'
        self.$store.dispatch('getLid')
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("isOpen Error adding document: ", error)
        self.isOpen = "public"
        self.oneideaTheme = ""
        self.oneideaHolder = ""
        self.onelidName = ""
        self.inHomeTo = "idea"
        self.postIdeaOnContent = 'false'
        self.postIdeaAnonymous = 'true'
        self.isOpenIdeaThread = 'false'
        self.isIdeaSubmitDisabled = 'false'
      })
      //console.log("submitlid",this.oneLid,this.tagNames,this.tagColors,this.onelidName,this.oneLid.title,this.onelidName != this.oneLid.title,this.oneideaDesc,this.oneideaTheme,this.isOpen)
    },
    //Lid更新
    submitLidTags() {
      let self = this
      if(this.tagNames.length>0&&!this.isEmpty&&this.isUnDup){
        this.db.collection("0").doc(this.lidId).update({
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          tags:{
            title: self.tagNames,
            color: self.tagColors,
            required: self.tagRequired || false,
            oldtagHided: self.oldtagHided || false
          },
        }).then(function(docRef) {
        // 保存に成功した時
          let tags = {
            title: self.tagNames,
            color: self.tagColors,
            required: self.tagRequired || false,
            oldtagHided: self.oldtagHided || false
          }
          self.onetags={}
          self.$set(self.onetags,"title",self.tagNames)
          self.$set(self.onetags,"color",self.tagColors)
          self.$set(self.onetags,"required",self.tagRequired)
          self.$set(self.onetags,"oldtagHided",self.oldtagHided)
          self.$set(self.navlid[self.lidIndex],"tags",tags)
          self.tagNames = []
          self.tagColors = []
          self.tagNum = 0
          self.tagNum_ = 0
          self.tagRequired = false
          //self.$store.dispatch('getLid')
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("LidTags Error adding document: ", error)
        })
      }
    },
    removingSublid(){
      let self = this
      this.today()
      //console.log("lid削除")
      //this.$store.dispatch('setLidNotify',({title:`${self.$t('Lid')}の削除`,content:`${self.$t('Lid')}:${self.onelidName}が削除されました。`,address:"all",type:4,lidId:self.lidId,tag:"Lid"}))
      this.db.collection("0").doc(this.lidId).update({
        isActive:false,
        becauseRemove:this.removeReason,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("Document written with ID: ", docRef.id)
        self.setLid = false
        self.removeReason = ''
        self.removeSublid = false
        self.checkRemoveSublid = false
        self.$store.dispatch('getLid')
        self.$store.dispatch('setConfigNotify',({title:`${self.$t('Lid')}の削除`,content:`${self.$t('Lid')}:${self.onelidName}が削除されました。`,address:"all",type:4,lidid:docRef.id,tag:"Lid"}))
        self.reload()
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Error adding document: ", error)
      })
    },
    submitNotice() {
      let self = this,index;
      let collection = this.db.collection("0").doc(self.lidId)
      collection.set({
        notice: self.notice,
        noticeTime: firebase.firestore.FieldValue.serverTimestamp(),
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("Document written with ID: ",self.notice)
        if(self.isLid==="lid") index = self.lid.findIndex((value) => value.id === self.lidId)
        else if(self.isLid==="alid") index = self.alid.findIndex((value) => value.id === self.lidId)
        self.lidTitle = ''
        self.navlid[self.lidIndex].notice = self.notice
        self.notice = ''
        self.navlid[self.lidIndex].noticeTime = firebase.firestore.Timestamp.fromDate(new Date())
        firebase.functions().httpsCallable('lidNoticeUpdated')({
          lidid: self.lidId,
          lidTitle: self.lidTitle,
          uid: self.uid,
        })
        self.$store.commit('setlidnotice', {isLid: self.isLid,index:index, notice:self.notice, noticeTime:firebase.firestore.Timestamp.fromDate(new Date())})
      }).catch(function(error) {
        // 保存に失敗した時
        alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
        //console.error("Error adding document:", error);
      })
    },
    getNotify(id){
      let self = this
      if(self.lidNotifyId !== id){
        self.lidNotify = []
        this.db.collection("0").doc(id).collection("notification").get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let oneno = doc.data()
            self.lidNotify.push(oneno)
          })
        })
        self.lidNotifyId = id   
      }
    },
    reload(){
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayyy = yyyy + mm + dd + hh + mi
      this.todayy = yyyy + mm + dd + hh + mi + se + ms
      this.timeday= mm+"-"+dd
      this.timehour= hh+":"+mi
      this.yyyymmdd = yyyy + mm + dd
      this.yyyymm = yyyy + mm
      this.yyyy = yyyy
      this.mm = mm

      this.day7 = mm + "-" + dd
      date.setDate(date.getDate() - 1)
      this.day6 = this.toDoubleDigits(date.getMonth() + 1) + "-" + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day5 = this.toDoubleDigits(date.getMonth() + 1) + "-" + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day4 = this.toDoubleDigits(date.getMonth() + 1) + "-" + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day3 = this.toDoubleDigits(date.getMonth() + 1) + "-" + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day2 = this.toDoubleDigits(date.getMonth() + 1) + "-" + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day1 = this.toDoubleDigits(date.getMonth() + 1) + "-" + this.toDoubleDigits(date.getDate())
      this.day7_ = yyyy +mm + dd
      date.setDate(date.getDate() - 1)
      this.day6_ = yyyy +this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day5_ = yyyy +this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day4_ = yyyy +this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day3_ = yyyy +this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day2_ = yyyy +this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      date.setDate(date.getDate() - 1)
      this.day1_ = yyyy + this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      //console.log(this.day1,this.day2,this.day3,this.day4,this.day5,this.day6,this.day7)
    },
    toDoubleDigits : function(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    onedoFold(el){
      //console.log("unfold:",el)
      this.unfold = el
    },
    onecandiMembers(el){
      this.candiMem = el
    },
    oneaddMember(el){
      this.lidMemview = el
    },
    oneaddAdmin(el){
      this.lidAdmview = el
    },
    closeProfile() {
      this.profile = false;
    },
    closeAuthModal() {
      this.authModal = false
    },
    openDetailNotification(){
      this.detailNotification = true
    },
    closeDetailNotification(){
      this.detailNotification = false
    },
  }
}
</script>
<style scoped>
main >>> .v-main{
  height:0px !important;
}
.areapj {
  position: relative;
  overflow: hidden;
}
.gren1 {
  text-align: left;
  color: #399942 !important;
  font-family:mplus-2c-medium;
  font-weight: bold;
  font-size: 13px;
}
.gren2 {
  text-align: left;
  color: #BA0009 !important;
  font-family:mplus-2c-medium;
  font-weight: bold;
  font-size: 13px;
}
.pl312{
  padding-left:312px !important;
}
.pl80{
  padding-left:80px !important;
}
.dog{
  position: relative;
  top:65px;
  left:10%;
}
.noScroll::-webkit-scrollbar{
  display: none;
}
::-webkit-scrollbar{
  display: scroll;
}
*{
  font-family:mplus-2c-medium !important;
}
</style>
